import RequireSuperAdminMiddleware from 'middlewares/RequireSuperAdminMiddleware'

const middlewares = [RequireSuperAdminMiddleware]

export default [
    {
        path: '/intelligence',
        name: 'intelligence',
        redirect: { name: 'intelligence.overview' },
    },
    {
        path: '/intelligence/overview',
        name: 'intelligence.overview',
        view: 'intelligence/Overview',
        middlewares,
    },
    {
        path: '/intelligence/constraints',
        name: 'intelligence.constraints',
        view: 'intelligence/Constraints',
        middlewares,
    },
    {
        path: '/intelligence/delivery',
        name: 'intelligence.delivery',
        view: 'intelligence/Delivery',
        middlewares,
    },
    {
        path: '/intelligence/supply-demand',
        name: 'intelligence.supply-demand',
        view: 'intelligence/SupplyDemand',
        middlewares,
    },
    {
        path: '/intelligence/entitlement',
        name: 'intelligence.entitlement',
        view: 'intelligence/Entitlement',
        middlewares,
    },
    {
        path: '/intelligence/patient-friction',
        name: 'intelligence.patient-friction',
        view: 'intelligence/PatientFriction',
        middlewares,
    },
    {
        path: '/intelligence/provider-performance',
        name: 'intelligence.provider-performance',
        view: 'intelligence/ProviderPerformance',
        middlewares,
    },
]
